import type { Filter } from "../../layout/types";
import type { FilterFieldType } from "./types";
import { resolvePath } from "./use-filter-schema";

// How the side panel edits each type of the filter schema. Records (« Registration is … ») have
// no side panel input: they stay in the advanced editor.
const SIDE_PANEL_TYPES: Partial<Record<FilterFieldType, Filter["type"]>> = {
    text: "text",
    number: "number",
    boolean: "checkbox",
    date: "date-range",
    datetime: "datetime-range",
    choice: "select",
    picklist: "select"
};

/**
 * The side panel definition of a field of a linked object (`registration__email`), read from the
 * filter schema: « Registration › Email », with the field's type and values.
 */
export async function linkedFilterFromPath(rootModel: string, path: string): Promise<Filter | null> {
    const resolved = await resolvePath(rootModel, path);
    const field = resolved?.field;
    const type = field ? SIDE_PANEL_TYPES[field.type] : undefined;
    if (!resolved || !field || !type) return null;
    return {
        field_name: path,
        name: resolved.labels.join(" › "),
        description: field.description,
        type,
        options: field.options,
        optionsUrl: field.options ? undefined : field.options_url
    };
}
